import { render, staticRenderFns } from "./TableTreeview.vue?vue&type=template&id=01d70a20&scoped=true&"
import script from "./TableTreeview.vue?vue&type=script&lang=js&"
export * from "./TableTreeview.vue?vue&type=script&lang=js&"
import style0 from "./TableTreeview.vue?vue&type=style&index=0&id=01d70a20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d70a20",
  null
  
)

export default component.exports